<template>
  <div class="col-md-12">
    <div class="d-flex flex-row justify-content-between">
      <div>
        <h1>{{$route.meta.title}}</h1>
      </div>
      <div class="d-flex justify-content-end" v-if="canSearch">
        <div class="mr-2">
          <router-link :to="`${path}create`" class="blueBtn">Create {{$route.meta.title}}</router-link>
        </div>
        <div>
          <div class="input-group md-form form-sm form-1 pl-0">
            <div class="input-group-prepend">
              <span class="input-group-text" id="basic-text1">
                <i class="fa fa-search" aria-hidden="true"></i>
              </span>
            </div>
            <input
              class="form-control searchInput"
              type="search"
              placeholder
              aria-label="Search"
              v-model="searchTerm"
              @keyup.enter="search"
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  data () {
    return {
      searchTerm: ''
    }
  },
  props: {
    canSearch: {
      type: Boolean,
      required: true
    }
  },
  mounted () {
  },
  methods: {
    search (event) {
      let term = { search: this.searchTerm }
      if (!this.isEmpty(term)) {
        this.$emit('searchterm', term)
      }
    },
    isEmpty (str) {
      return (!str || str.length === 0)
    }
  },
  computed: {
    path () {
      return this.$route.matched[1].path
    }
  },
  components: {

  }
}
</script>
<style lang="scss" scoped>
#label {
  margin: 0px;
}
</style>
